<script setup lang="ts">
import LeButton from "@dsk/components/Button/LeButton.vue";
import LeEducation from "@dsk/icons/LeEducation.vue";
import { useI18n } from "vue-i18n";

import { config } from "@/config";

import LeErrorResult from "./LeErrorResults.vue";

const { t } = useI18n();
const { language } = config.app;
</script>

<template>
  <div class="le-concurrent-license-not-available-error__info-box">
    <LeEducation width="20" height="20" />
    <span>
      <span
        class="le-concurrent-license-not-available-error__emphasize le-concurrent-license-not-available-error__emphasize--spacing"
      >
        {{ t("le-error-results.concurrent-license-not-available.info-box.headline") }}
      </span>
      <i18n-t keypath="le-error-results.concurrent-license-not-available.info-box.text">
        <template #site>
          <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
          <a href="https://abc.ordbogen.com" class="le-concurrent-license-not-available-error__link" target="_blank"
            >abc.ordbogen.com</a
          >
          <!-- eslint-enable @intlify/vue-i18n/no-raw-text -->
        </template>
      </i18n-t>
    </span>
  </div>

  <LeErrorResult>
    <template #header>
      {{ t("le-error-results.concurrent-license-not-available.headline") }}
    </template>
    <template #paragraph1>
      {{ t("le-error-results.concurrent-license-not-available.paragraph1-1") }}
      <br />
      {{ t("le-error-results.concurrent-license-not-available.paragraph1-2") }}
    </template>
    <template #paragraph2>
      {{ t("le-error-results.concurrent-license-not-available.paragraph2") }}
    </template>
    <template #button>
      <LeButton tag="a" :href="`/${language}/support/`" variant="outline">{{
        t("le-error-results.concurrent-license-not-available.button")
      }}</LeButton>
    </template>
  </LeErrorResult>
</template>

<style lang="less">
@import "@dsk/styles/all";

.le-concurrent-license-not-available-error {
  &__info-box {
    display: flex;
    margin-bottom: 16px;
    padding: 12px 20px;
    border-radius: 4px;
    background-color: @colors[@accent][200];
    color: @colors[@accent][900];
    gap: 10px;
    .body-text("s");
  }

  &__emphasize {
    .body-text("s", "bold");

    &--spacing {
      margin-right: 4px;
    }
  }

  &__link {
    .link();
    .body-text("s");
  }
}
</style>
